import {
  params,
  string as stringType,
  shape as shapeType,
  arrayOf as arrayType,
} from '@thd-nucleus/data-sources';

export const kitchenCabinetModel = {
  fetchCollectionsContent: params({ collectionName: stringType().isRequired() }).shape({
    title: stringType(),
    media: shapeType({
      images: arrayType(shapeType({
        url: stringType()
      }))
    })
  })
};